import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import Editexpensemodal from "./editexpensemodal";
import moment from "moment/moment";
import money_rounding from "../../utils/money_rounding";
import iqd_rounding from "../../utils/iqd_rounding";

const Expenselist = () => {
  const { initState, recaller, setrecaller, clear, initDispatch } =
    useContext(GlobalContext);

  const [expense_id, setexpense_id] = useState();
  const [expense_amount, setexpense_amount] = useState();
  const [expense_type_id, setexpense_type_id] = useState();
  const [expense_note, setexpense_note] = useState();
  const [expense_date, setexpense_date] = useState();
  const [show, setshow] = useState();
  return (
    <div>
      <Editexpensemodal
        show={show}
        setshow={setshow}
        expense_id={expense_id}
        expense_amount={expense_amount}
        setexpense_amount={setexpense_amount}
        expense_type_id={expense_type_id}
        setexpense_type_id={setexpense_type_id}
        expense_note={expense_note}
        expense_date={expense_date}
        setexpense_date={setexpense_date}
        setexpense_note={setexpense_note}
      />

      {/* Expense List Card */}
      <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
        
        {/* Section Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
          <h2 className="text-base font-semibold text-slate-800">لیستی خەرجی</h2>
        </div>

        {/* Table */}
        <table className="w-full">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-100">
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                جۆری خەرجی
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                بڕی خەرجی
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                بەروار
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                یوزەر
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                تێبینی
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                گۆڕانکاری
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
            {initState.expense.map((lis) => (
              <tr key={lis.expense_id} className="hover:bg-slate-50 transition-colors duration-100">
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                    {lis.expense_type_name}
                </td>
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                    {numberbeautify(
                      iqd_rounding(money_rounding(lis.expense_amount))
                    )}
                </td>
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                    {moment(lis.expense_date).format("YYYY-MM-DD")}
                </td>
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                    {lis.user_name}
                </td>
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                    {lis.expense_note}
                </td>
                <td className="px-6 py-4 text-right">
                  <button
                    className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-amber-50 text-amber-700 hover:bg-amber-100 border border-amber-200 transition-colors cursor-pointer"
                    onClick={() => {
                      setexpense_id(lis.expense_id);
                      setexpense_amount(lis.expense_amount);
                      setexpense_type_id(lis.expense_type_id);
                      setexpense_note(lis.expense_note);
                      setexpense_date(
                        moment(lis.expense_date).format("YYYY-MM-DD")
                      );
                      setshow(true);
                    }}
                  >
                    گۆڕانکاری
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Expenselist;
